// extracted by mini-css-extract-plugin
module.exports = {"PlacesSectionTitle":"PlacesSection_PlacesSectionTitle__2eXmb"};